var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashMobMid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 116,
    viewBox: "0 0 130 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 115.322C130 99.1096 116.857 85.9668 100.645 85.9668C84.4334 85.9668 71.2905 99.1096 71.2905 115.322H130Z",
    fill: "#A2FAA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5483 50.3223H100.645V115.322H33.5483V50.3223Z",
    fill: "#0032C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1129 67.0957L48.2258 115.322H0L24.1129 67.0957Z",
    fill: "#1E56FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0968 0C80.9932 0 92.2581 11.2649 92.2581 25.1613C92.2581 39.0577 80.9932 50.3226 67.0968 50.3226C53.2005 50.3226 41.9355 39.0577 41.9355 25.1613C41.9355 11.2649 53.2005 0 67.0968 0Z",
    fill: "#1E56FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashMobMid);
export default __webpack_public_path__ + "static/media/dash-mob-mid.b3c93eb077c1c2d7f4ce9e3794772318.svg";
export { ForwardRef as ReactComponent };